import Button from 'components/UI/V3/Button/Button';
import { FunctionComponent, ReactNode, useState } from 'react';
import GenericModal from '../GenericModal';
import styles from './GenericDeleteModal.module.scss';

interface GenericDeleteModalProps {
    title: JSX.Element;
    body: JSX.Element;
    isLoading?: boolean;
    className?: string;
    zIndex?: number;
    confirmLabel?: string;
    onConfirm: () => void;
    onCancel: () => void;
}

export const GenericDeleteModal: FunctionComponent<GenericDeleteModalProps> = props => {
    const [loading, setLoading] = useState(false);

    const confirmHandler = () => {
        setLoading(true);
        props.onConfirm();
    };

    return (
        <GenericModal
            className={props.className}
            zIndex={props.zIndex}
            footer={
                <div className={styles.footer}>
                    <div className={styles.left}>
                        <Button
                            className={styles.button}
                            label="No"
                            onClick={props.onCancel}
                            variant="black"
                        />
                    </div>
                    <div className={styles.right}>
                        <Button
                            className={styles.button}
                            label={props.confirmLabel ?? 'Yes'}
                            onClick={confirmHandler}
                            variant="danger"
                            // Callers that own the request state drive the spinner via the prop;
                            // the internal flag is the fallback for those that don't pass it.
                            isLoading={props.isLoading ?? loading}
                        />
                    </div>
                </div>
            }
            onClose={props.onCancel}
        >
            {props.title}
            {props.body}
        </GenericModal>
    );
};

export default GenericDeleteModal;
